import { useTranslation } from 'react-i18next'

const MumBefore = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      role="image"
      aria-labelledby="mum-before-title"
      viewBox="0 0 1920 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="mum-before-title">{t('antagonists:mum:components:start')}</title>
      <defs>
        <clipPath id="mum-b">
          <path
            d="M1573.02 959.49c-2.57.53-3.53 3.62-3.84 10.79-.31 7.16.25 10.73.64 15.75.68 8.68 2.27 15.03 2.27 15.03s16.19-1.55 36.92-1.58 26.85 2.01 38.22.7c4.68-.54 13.01-1.28 19.39-3.33 6.38-2.05 10.32-5.68 10.32-5.68s-1.57-9.93-3.64-12.03c-2.07-2.1-4.03-3.53-9.52-4.62-5.5-1.1-17.34-3.85-26.95-9.5-9.31-5.47-26.03-19.08-28.23-19.01-2.76.09-6.02 2.92-8.76 7.52s-5.9 15.36-14.44 15.48c-12 .17-12.38-9.49-12.38-9.49Z"
            style={{
              fill: '#f1f1f3',
            }}
          />
        </clipPath>
        <clipPath id="mum-c">
          <path
            d="M1480.48 953.5c-5.96 1.8-17.28 14.92-19.3 14.8-2.02-.12-2.02-5.24-1.79-7.62l.24-2.38s-2.98 4.17-5.48 14.41c-2.5 10.24-2.86 24.42-2.86 24.42s9.89 4.05 13.34 8.22c3.45 4.17 8.58 9.29 18.7 10.12 10.12.83 32.52-.95 34.18-1.79s.36-12.15-.6-13.94c-.95-1.79-2.62-2.98-2.62-2.98s-1.79-2.26-5.6-11.55c-3.81-9.29-8.81-18.46-11.55-22.04-2.74-3.57-10.35-11.59-16.67-9.68Z"
            style={{
              fill: '#f1f1f3',
            }}
          />
        </clipPath>
        <clipPath id="mum-d">
          <path
            d="M1532.73 301.56s4.55 18.2-4.17 30.33c-8.72 12.13-37.16 19.72-37.16 19.72l-.76 55.35 113.36-6.45-2.27-27.3s-9.48-3.38-22.37-13.23c-12.89-9.86-4.8-21.28-2.27-27.71 1.69-4.29 4.55-18.2 4.55-18.2l-48.91-12.51Z"
            style={{
              fill: '#e2a972',
            }}
          />
        </clipPath>
        <clipPath id="mum-e">
          <path
            d="M1541.43 336.02c4.5 4.01 15.12 4.22 18.84 2.44 8.79-4.2 17.02-12.38 20.92-17.13 8.7-10.6 9.41-18 9.2-30.8-.12-7.31-4.67-12-4.67-12l-65.02-5.07s-.44 3.31-1.71 9.8c-2.23 11.39-2.49 21.51 3.66 32.5 7.27 12.98 11.33 13.61 18.79 20.26Z"
            style={{
              fill: '#e2a972',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:#f8f7f0}.g{fill:#eb6a36}.h{fill:#e9b926}.i{fill:#f1f1f3}.j{fill:#c4c7c9}.k{fill:#e2a972}.l{fill:#1c3628}.m{fill:#2e425b}.n{fill:#272a3e}.o{clip-path:url(#mum-c)}.p{clip-path:url(#mum-b)}.q{clip-path:url(#mum-e)}.r{clip-path:url(#mum-d)}'
          }
        </style>
      </defs>
      <path
        d="M1641.24 465.98s18.93-40.25 22.82-41.17c7.95-1.89 30.47-8.76 32.68-11.44 2.22-2.68 9.71-17.94 10.42-19.42 2.02-4.18 6.79-11.48 6.79-11.48s-5.25-2.43-9.71.44c-2.5 1.61-8.77 8.63-16.38 12.18-6.57 3.06-11.33 6.52-13.29 1.99-1.52-3.52 8.92-6.98 11.46-10.01 2.74-3.27.58-6.96.58-6.96s-17.33 7.66-21.89 10.5c-4.37 2.72-14.3 19.19-17.87 20.96-1.71.85-28.58 37.99-28.58 37.99l22.95 16.42Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1566.77 212.5c-32.94-4-56.92 18.87-61.3 48.3-4.15 27.93-1.75 65.31-.85 64.92.13-.05 56.59 31.48 112.45 8.23 0 0-8.93-34.18-5.98-58.47 2.95-24.29-14.34-59.33-44.32-62.97Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1531.33 675.97s33.49 102.3 30.9 114.77c-2.59 12.47-10.4 27.44-10.07 52.17.33 24.73 16.28 85.92 17.33 96.35 1.64 16.32 2.75 29.88 2.75 29.88l17.05 6.75 24.79-14.36s-5.75-9.52-9.29-23.64c-3.54-14.11 1.98-55.42 3.37-77.49 1.39-22.07 3.51-47.84 3.55-53.71.05-5.88 3.99-15.96 2.03-28.36-1.97-12.41.45-30.07-2.72-50.11-3.18-20.04-11.34-65.37-11.34-65.37l-68.35 13.11Z"
        style={{
          fill: '#e9b926',
        }}
      />
      <path
        d="M1573.02 959.49c-2.57.53-3.53 3.62-3.84 10.79-.31 7.16.25 10.73.64 15.75.68 8.68 2.27 15.03 2.27 15.03s16.19-1.55 36.92-1.58 26.85 2.01 38.22.7c4.68-.54 13.01-1.28 19.39-3.33 6.38-2.05 10.32-5.68 10.32-5.68s-1.57-9.93-3.64-12.03c-2.07-2.1-4.03-3.53-9.52-4.62-5.5-1.1-17.34-3.85-26.95-9.5-9.31-5.47-26.03-19.08-28.23-19.01-2.76.09-6.02 2.92-8.76 7.52s-5.9 15.36-14.44 15.48c-12 .17-12.38-9.49-12.38-9.49Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-b)',
        }}
      >
        <path
          d="M1561.39 987.59s20.14-2.15 29.81-2.41c9.68-.26 32.93-.24 47.34-.56 14.41-.32 25.47-4.27 28.38-6.35s4.75-4.34 4.75-4.34l9.1 17.99s-13.49 12.67-13.95 12.74c-.45.07-103.27-1.22-103.27-1.22l-2.16-15.85Z"
          style={{
            fill: '#c4c7c9',
          }}
        />
      </g>
      <path
        d="M1476.9 682.29s-18.85 73.92-22.4 93.41c-3.54 19.49-12.66 55.48-12.73 88.27-.07 31.73 10.82 62.74 14.97 77.08 2.71 9.36 2.19 31.34 2.19 31.34s31.23-1.94 31.23-2.91c0-.97 0-12.24-2.58-19s-3.22-15.46-2.25-24.48c.97-9.02 5.47-70.21 7.73-84.38 2.25-14.17 4.51-28.82 8.37-41.06 3.86-12.24 28.65-50.46 29.94-69.14 1.29-18.68-11.58-48.09-11.58-48.09l-42.9-1.05Z"
        style={{
          fill: '#e9b926',
        }}
      />
      <path
        d="M1480.48 953.5c-5.96 1.8-17.28 14.92-19.3 14.8-2.02-.12-2.02-5.24-1.79-7.62l.24-2.38s-2.98 4.17-5.48 14.41c-2.5 10.24-2.86 24.42-2.86 24.42s9.89 4.05 13.34 8.22c3.45 4.17 8.58 9.29 18.7 10.12 10.12.83 32.52-.95 34.18-1.79s.36-12.15-.6-13.94c-.95-1.79-2.62-2.98-2.62-2.98s-1.79-2.26-5.6-11.55c-3.81-9.29-8.81-18.46-11.55-22.04-2.74-3.57-10.35-11.59-16.67-9.68Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-c)',
        }}
      >
        <path
          d="M1448.9 978.82s5.83 4.91 11.65 8.91c5.83 4 10.28 9.03 17.25 9.94 6.97.91 19.08 1.14 25.71 1.03 6.63-.11 12.8-1.6 12.8-1.6s7.31 4.46 7.31 4.11-2.63 23.77-2.63 23.77-62.16 3.66-62.04 3.08c.11-.57-17.37-39.88-17.71-39.88s7.66-9.37 7.66-9.37Z"
          style={{
            fill: '#c4c7c9',
          }}
        />
      </g>
      <path
        d="M1484.12 580.38s-16.07 35.94-17.5 75.96c-1.43 40.02-23.33 147.12-23.33 147.12s61.14 14.8 108.3 11.94c47.17-2.86 81.45-16.18 81.45-16.18s7.13-151.37 9.05-181.21c1.37-21.2-20.77-91.93-20.77-91.93l-137.21 54.31Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1558.89 333.69s-40.95-1.14-54.98-.76c-14.03.38-17.44 6.07-20.09 15.92-2.65 9.86-1.9 39.43-1.9 39.43l123.22 16.68s4.17-28.06 0-39.81c-4.17-11.75-19.34-29.57-46.26-31.47Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1532.73 301.56s4.55 18.2-4.17 30.33c-8.72 12.13-37.16 19.72-37.16 19.72l-.76 55.35 113.36-6.45-2.27-27.3s-9.48-3.38-22.37-13.23c-12.89-9.86-4.8-21.28-2.27-27.71 1.69-4.29 4.55-18.2 4.55-18.2l-48.91-12.51Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-d)',
        }}
      >
        <path
          d="M1491.4 346.15s51.03 20.22 60.65 21.18c9.63.96 53.91-6.74 53.91-6.74l21.18 11.55-41.4 93.39-87.61-34.66-11.55-80.87 4.81-3.85Z"
          style={{
            fill: '#f8f7f0',
          }}
        />
      </g>
      <path
        d="M1459.35 360.95c-7.58 8.05-26.99 40.1-33.93 61.7-5.17 16.08-23.49 63.18-18.19 79.48s13.93 35.59 29.75 52.4c12.34 13.11 31.62 26.22 31.62 26.22s-3.35 12.62-5.25 26.65-3.2 28.84-3.2 28.84 67.65 13.75 116.93 4.27c49.29-9.48 75.83-19.34 75.83-19.34l-25.34-95.96s8.98-128.25-1.64-141.9c-10.62-13.65-45.57-28.79-45.57-28.79s-16.73 31.46-25.58 38.83c-2.56 2.13-29.13-51.38-46.08-54.78-9.01-1.81-43.29 15.92-49.36 22.37Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="m1485.27 553.45-8.87 21.95s9.34 2.42 12.45 6.23c3.11 3.81 14.88 10.72 22.49 13.15 7.61 2.42 16.95 4.5 16.95 4.5l6.92-43.59s-20.68-.35-28.64 1.03c-7.96 1.38-12.18.7-14.95-.34-2.77-1.04-6.35-2.92-6.35-2.92Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1519.08 520.33s-4.17 37.91-11.37 56.11c-7.2 18.2-12.89 27.3-12.89 27.3l-.76 15.54s39.05 6.07 77.34-1.52c38.29-7.58 66.73-17.44 66.73-17.44l-3.41-22.75-34.88-64.07-80.76 6.82Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1541.43 336.02c4.5 4.01 15.12 4.22 18.84 2.44 8.79-4.2 17.02-12.38 20.92-17.13 8.7-10.6 9.41-18 9.2-30.8-.12-7.31-4.67-12-4.67-12l-65.02-5.07s-.44 3.31-1.71 9.8c-2.23 11.39-2.49 21.51 3.66 32.5 7.27 12.98 11.33 13.61 18.79 20.26Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-e)',
        }}
      >
        <path
          d="M1546.78 270.82s-7.92-6.56-12.84-6.22c-6.88.48-9.02.68-9.02.68l-.02 3.41s5.64.59 8.18.64c4.13.08 12.02 5.77 12.02 5.77s2.1-4.46 1.68-4.27ZM1567.65 272.22s7.44-2.18 12.65-2.6c5.21-.42 11.91 3 11.91 3l-1.35 3.52s-7.89-2.89-10.54-1.99c-3.03 1.02-12.24 2.64-12.24 2.64s-.79-4.85-.43-4.56Z"
          style={{
            fill: '#1c3628',
          }}
        />
      </g>
      <path
        d="M1565.49 319.95c-.36 3.58-6.79 5.15-12.24 4.62-5.28-.51-11.37-2.62-11.11-6.32.13-1.91 4.35-7.57 8.13-7.82 2.4-.16 2.92.69 4.21.74.85.03 1.22-.59 3.99-.13 2.63.44 7.24 6.69 7.01 8.91Z"
        style={{
          fill: '#eb6a36',
        }}
      />
      <path
        d="M1535.55 277.68c-1.75 1.21-2.17 3.24-.92 4.92 1.25 1.67 3.25 2.02 4.88 1.03 1.94-1.17 1.88-3.16.77-5-.79-1.31-2.93-2.19-4.73-.94Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1542.22 278.66-6.21-2.74-8.39-2.37-.04 2.91 7.3 2.22 6.15 2.67 1.19-2.69zM1574.24 281.71c1.41 1.6 1.33 3.67-.29 4.99-1.62 1.32-3.63 1.18-4.99-.17-1.6-1.6-1.07-3.51.46-5.04 1.08-1.08 3.37-1.42 4.82.22Z"
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1567.53 281.06 6.69-1.17 8.71-.29-.66 2.84-7.61.4-6.62 1.12-.51-2.9z"
      />
      <path
        d="m1647.92 406.87 18.91 25.52s-12.13 25.2-20.96 39.17c-8.83 13.97-41.15 61.31-41.15 61.31l-14.96-88.65s27.1-13.85 34.57-19.96c7.47-6.11 23.59-17.39 23.59-17.39Z"
        style={{
          fill: '#272a3e',
        }}
      />
    </svg>
  )
}

export default MumBefore